import React from "react";
import MenuSelect from "../../ui/MenuSelect";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "../../ui/Collapsible";
import { Row } from "./PhysicsPanelControls";

export default function PhysicsRuntimeControlsSection({
  motorGain,
  realtimeScale,
  setMotorGain,
  setRealtimeScale,
}) {
  return (
    <>
      <div className="h-px bg-gray-700 my-2" />
      <Collapsible defaultOpen>
        <CollapsibleTrigger quiet className="w-full text-xs text-gray-200 justify-between">
          Runtime Controls
        </CollapsibleTrigger>
        <CollapsibleContent>
          <Row label="Speed">
            <input
              type="range"
              min={0.1}
              max={2}
              step={0.05}
              value={realtimeScale}
              className="min-w-0 flex-1 h-2 slider"
              aria-label="Simulation speed"
              onChange={(e) => setRealtimeScale(parseFloat(e.target.value))}
            />
            <span className="min-w-[3.25rem] text-right text-xs text-gray-300 tabular-nums select-none">
              {realtimeScale.toFixed(2)}x
            </span>
          </Row>
          <Row label="Motor Gain">
            <MenuSelect
              size="compact"
              className="w-full min-w-0"
              value={String(motorGain)}
              onChange={(v) => setMotorGain(parseFloat(v))}
              options={[
                { value: "1", label: "1x" },
                { value: "3", label: "3x" },
                { value: "5", label: "5x" },
                { value: "10", label: "10x" },
              ]}
              triggerProps={{ onPointerDown: (e) => e.stopPropagation() }}
              aria-label="Motor gain"
            />
          </Row>
        </CollapsibleContent>
      </Collapsible>
      <div className="h-px bg-gray-700 my-2" />
    </>
  );
}
